import type { MinimalTaskRun } from "src/queries/tasks/tasks.types";

type TaskRunForPitSelector = MinimalTaskRun & { last_run?: string };

/**
 * Runs come newest-first by start_time, so a rerun of an older PIT can land
 * between other PITs' runs. Keep each PIT's runs together under its newest
 * run, since the selector nests a PIT's later rows as its reruns.
 * Drops `last_run` so the Pit component uses `start_time`.
 */
export const groupTaskRunsByPit = (
  runs: TaskRunForPitSelector[]
): MinimalTaskRun[] => {
  // Key order follows the first run of each PIT, which is its newest.
  const runsByPit = Object.groupBy(runs, (task) => task.app_pit);
  const pitGroupsNewestFirst = Object.values(runsByPit);

  const runsKeptWithTheirPit = pitGroupsNewestFirst.flatMap(
    (pitRuns) => pitRuns ?? []
  );

  return runsKeptWithTheirPit.map((task) => {
    const { last_run, ...run } = task;
    return run;
  });
};
